import { useState, useEffect, useCallback, useRef } from "react";
// import { generatePDF } from "@/utils/pdfGenerator"; // adjust path if needed
import {  useNavigate, useLocation } from "react-router-dom";
import Navbar from "./components/navbar"; // Update import to use the same Navbar as discover_page
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // Import back arrow icon
import { Alert, AlertIcon, AlertTitle } from "./components/ui/alert";
// import { LoaderCircular } from "./components/ui/loader";
import axios from "axios";
import { BASE_URL } from "./apiConfig";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import Footer from "./components/Footer";
import RippleWaveLoader from "./components/ui/RippleWaveLoader";
import { jsPDF } from "jspdf";
import DownloadIcon from "@mui/icons-material/Download";

const DetailsPage = () => {
  // const { id } = useParams();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  // Details state
  const [details, setDetails] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState<string | null>(null);

  // Alert states
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [pdfAlert, setPdfAlert] = useState<{ open: boolean; message: string; type: "success" | "error" }>({ open: false, message: "", type: "success" });
  const [pdfDownloadMessage, setPdfDownloadMessage] = useState<string>("");

  // Active tab state
  // const [activeTab, setActiveTab] = useState("problem");
  const [openSolutionSource, setOpenSolutionSource] = useState<number | null>(null);
  const [openStatsSource, setOpenStatsSource] = useState<number | null>(null);
  const [openDatasetSource, setOpenDatasetSource] = useState<number | null>(null);
  const [openAdoptedSource, setOpenAdoptedSource] = useState<number | null>(null);
  const [openBlogSource, setOpenBlogSource] = useState<number | null>(null);
  const [activeSection, setActiveSection] = useState<string>("solutions");

  // Company info states
  // const [openCompanyInfoDropdown, setOpenCompanyInfoDropdown] = useState<number | null>(null);
  // // const [companyInfoLoading, setCompanyInfoLoading] = useState<{ [key: number]: boolean }>({});
  // const [adoptedCompanyInfo, setAdoptedCompanyInfo] = useState<{ [key: number]: any }>({});

  // Approve loading state
  const [approveLoading, setApproveLoading] = useState(false);

  // Scroll to top button state
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [isDownloadingPdf, setIsDownloadingPdf] = useState(false);

  const toggleMobileMenu = () => setMobileMenuOpen((prev) => !prev);

  const [moreProvidersLoading, setMoreProvidersLoading] = useState(false);

  // Fetch solution details from backend using location.state
  useEffect(() => {
    const fetchSolutionDetails = async () => {
      const incomingTitle = location.state?.title;
      const forceFetch = location.state?.forceFetch;

      // If explicit forceFetch requested, clear cached
      if (forceFetch) {
        sessionStorage.removeItem("solutionDetails");
      }

      // If navigation passed a previousDetails object AND it matches current title (or no title provided),
      // reuse it; otherwise ignore it and fetch fresh.
      if (location.state?.previousDetails) {
        const prev = location.state.previousDetails;
        const matches = !incomingTitle || prev.title === incomingTitle;
        if (matches && !forceFetch) {
          setDetails(prev);
          sessionStorage.setItem("solutionDetails", JSON.stringify(prev));
          return;
        }
      }

      // Try cached, but only if same title
      const cachedRaw = sessionStorage.getItem("solutionDetails");
      if (cachedRaw) {
        try {
          const cached = JSON.parse(cachedRaw);
          if (!incomingTitle || cached?.title === incomingTitle) {
            setDetails(cached);
            return;
          }
        } catch {
          // ignore parse errors -> proceed to fetch
        }
      }

      // If we have no location.state with minimum identifiers, do nothing
      if (!location.state) return;

      setLoading(true);
      setFetchError(null);
      setShowSuccessAlert(false);
      setShowErrorAlert(false);
      try {
        const response = await axios.post(`${BASE_URL}/search_solutions`, location.state, {
          headers: { "Content-Type": "application/json" },
          timeout: 180000,
        });
        const data = response.data;
        if (data.data && data.data.length > 0 && data.data[0] && !Array.isArray(data.data[0])) {
          const detailsObj = {
            ...data.data[0],
            country: location.state.country,
            is_approved: false,
          };
          setDetails(detailsObj);
          sessionStorage.setItem("solutionDetails", JSON.stringify(detailsObj));
          setShowSuccessAlert(true);
          setTimeout(() => setShowSuccessAlert(false), 3000);
        } else {
          setDetails(null);
          setFetchError(data.message || "No data returned from the server. Please try again.");
        }
      } catch (error: any) {
        setDetails(null);
        const msg = error?.response?.data?.message || error?.message || "Failed to load details. Please try again.";
        setFetchError(msg);
      } finally {
        setLoading(false);
      }
    };
    fetchSolutionDetails();
  }, [location.state]);

  // const handleCompanyInfoDropdown = async (index: number, firmName: string) => {
  //   if (openCompanyInfoDropdown === index) {
  //     setOpenCompanyInfoDropdown(null);
  //     return;
  //   }
  //   setOpenCompanyInfoDropdown(index);
  //   if (!adoptedCompanyInfo[index]) {
  //     setCompanyInfoLoading((prev) => ({ ...prev, [index]: true }));
  //     try {
  //       const response = await fetch(`${BASE_URL}/get_firm_info`, {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json' },
  //         body: JSON.stringify({ firm_name: firmName }),
  //       });
  //       if (response.ok) {
  //         const data = await response.json();
  //         setAdoptedCompanyInfo((prev) => ({ ...prev, [index]: data.data }));
  //       }
  //     } catch (e) {
  //       // Optionally show an error alert here
  //     }
  //     setCompanyInfoLoading((prev) => ({ ...prev, [index]: false }));
  //   }
  // };

  const handleApprove = async () => {
    if (!details) return;
    setApproveLoading(true);
    try {
      console.log("Approving use case with details:", details);
      const requested_user_id = localStorage.getItem("uid");
      const response = await fetch(`${BASE_URL}/add_usecase`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...details,
          ...(requested_user_id ? { requested_user_id } : {})
        }), // Just send the details as is
      });
      
      if (response.ok) {
        const result = await response.json();
        console.log("Approval success:", result);
        
        // Update local state
        const updatedDetails = { 
          ...details, 
          is_approved: true,
          usecase_id: result.id
        };
        
        setDetails(updatedDetails);
        
        // Update sessionStorage
        const savedResults = sessionStorage.getItem('discoveryResults');
        if (savedResults) {
          const resultsData = JSON.parse(savedResults);
          if (resultsData?.data && Array.isArray(resultsData.data)) {
            const updatedData = resultsData.data.map((item: any) => {
              if (item.title === details.title) {
                return { 
                  ...item, 
                  is_approved: true, 
                  usecase_id: result.id
                };
              }
              return item;
            });
            
            sessionStorage.setItem('discoveryResults', JSON.stringify({
              ...resultsData,
              data: updatedData
            }));
          }
        }
        
        setPdfAlert({ open: true, message: "Use case approved!", type: "success" });
      } else {
        // Error handling code remains the same
        const errorText = await response.text();
        console.error("Approval failed:", response.status, response.statusText, errorText);
        setPdfAlert({ open: true, message: `Failed to approve: ${response.status} ${response.statusText}`, type: "error" });
      }
    } catch (error) {
      console.error("Error approving use case:", error);
      setPdfAlert({ open: true, message: `Error: ${error instanceof Error ? error.message : "Unknown error"}`, type: "error" });
    }
    setApproveLoading(false);
  };

  const handleShowMoreProviders = async () => {
    if (!details) return;
    setMoreProvidersLoading(true);

    // Use normalized current list
    const existingList = extractProviders(details);
    const alreadyListed = existingList.map((c: any) => c?.company).filter(Boolean);

    try {
      const response = await fetch(`${BASE_URL}/solution_providers`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          title: details.title,
          description: details.description,
          already_listed_companies: alreadyListed,
        }),
      });
      const data = await response.json();

      // Normalize incoming
      const incoming: any[] = Array.isArray(data?.research_comp?.solution_providers)
        ? data.research_comp.solution_providers
        : Array.isArray(data?.research_comp)
          ? data.research_comp
          : [];

      if (data?.status === "success" && incoming.length) {
        setDetails((prev: any) => {
          const current = extractProviders(prev);
          const seen = new Set(current.map((r: any) => r?.company).filter(Boolean));
          const merged = [...current];

          incoming.forEach((p: any) => {
            const key = p?.company;
            if (key && !seen.has(key)) {
              merged.push(p);
              seen.add(key);
            }
          });

          // Force array at top-level for consistent rendering
          console.log("[solutions-provider] current:", current.length, "incoming:", incoming.length, "final:", merged.length);
          return { ...prev, research_comp: merged };
        });
      }
    } catch (e) {
      console.error("[solutions-provider] fetch failed:", e);
    } finally {
      setMoreProvidersLoading(false);
    }
  };
  const handleDownloadPDF = useCallback(async () => {
    if (!details) {
      setPdfDownloadMessage("No data available to generate PDF.");
      setShowErrorAlert(true);
      setTimeout(() => setShowErrorAlert(false), 3000);
      return;
    }

    setIsDownloadingPdf(true);

    try {
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
        compress: true,
      });

      const pageWidth = 210;
      const pageHeight = 297;
      const margin = 15;
      const usableWidth = pageWidth - margin * 2;
      const lineHeight = 6;
      let currentY = margin;

      const checkPageBreak = (requiredHeight = lineHeight) => {
        if (currentY + requiredHeight > pageHeight - margin) {
          pdf.addPage();
          currentY = margin;
          return true;
        }
        return false;
      };

      const wrapText = (text: string, maxWidth: number, fontSize = 10) => {
        pdf.setFontSize(fontSize);
        const lines = pdf.splitTextToSize(text || '', maxWidth);
        return Array.isArray(lines) ? lines : [lines];
      };

      const addText = (text: string, x: number, fontSize = 10, fontStyle: 'normal' | 'bold' | 'italic' = 'normal', color: [number, number, number] = [0,0,0]) => {
        const lines = wrapText(text, usableWidth - (x - margin), fontSize);
        pdf.setFontSize(fontSize);
        pdf.setFont('helvetica', fontStyle as any);
        pdf.setTextColor(color[0], color[1], color[2]);

        lines.forEach((line: string) => {
          checkPageBreak();
          pdf.text(line, x, currentY);
          currentY += lineHeight;
        });

        return lines.length;
      };

      const addLink = (text: string, url: string, x: number, fontSize = 10) => {
        const lines = wrapText(text, usableWidth - (x - margin), fontSize);
        pdf.setFontSize(fontSize);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(0, 0, 255);

        lines.forEach((line: string) => {
          checkPageBreak();
          pdf.textWithLink(line, x, currentY, { url });
          currentY += lineHeight;
        });

        return lines.length;
      };

      const addSectionHeader = (title: string, color: [number, number, number] = [70,70,200]) => {
        checkPageBreak(lineHeight * 2);
        currentY += 3;
        pdf.setFontSize(12);
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(color[0], color[1], color[2]);

        const lines = wrapText(title, usableWidth, 12);
        lines.forEach((line: string) => {
          pdf.text(line, margin, currentY);
          currentY += lineHeight;
        });

        currentY += 2;
      };

      // Title
      pdf.setFontSize(16);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(0, 0, 0);
      const titleText = details.title || "Solution Details";
      const titleLines = wrapText(titleText, usableWidth, 16);
      const contextInfo = "";

      titleLines.forEach((line: string) => {
        checkPageBreak(8);
        pdf.text(line, margin, currentY);
        currentY += 8;
      });

      if (contextInfo) {
        pdf.setFontSize(10);
        pdf.setFont('helvetica', 'italic');
        pdf.setTextColor(100, 100, 100);
        const contextLines = wrapText(contextInfo, usableWidth, 10);
        contextLines.forEach((line: string) => {
          checkPageBreak();
          pdf.text(line, margin, currentY);
          currentY += lineHeight;
        });
        currentY += 2;
      }
      currentY += 5;

      pdf.setDrawColor(200, 200, 200);
      pdf.line(margin, currentY, pageWidth - margin, currentY);
      currentY += 8;

      // Problem Statement
      if (details.description) {
        addSectionHeader("Problem Statement", [128, 0, 128]);
        addText(details.description, margin);
        currentY += 3;
      }

      // Solutions
      if (Array.isArray(details.solutions) && details.solutions.length) {
        addSectionHeader("Solutions", [0, 150, 0]);
        details.solutions.forEach((sol: any, index: number) => {
          checkPageBreak(lineHeight * 3);
          addText(`${index + 1}. ${sol.approach}`, margin + 5, 11, 'bold');
          if (sol.summary) addText(sol.summary, margin + 5, 10);
          if (sol["technology/tool"]) addText(`Technology/Tool: ${sol["technology/tool"]}`, margin + 5, 9, 'italic', [100,100,100]);

          if (sol.source && Array.isArray(sol.source) && sol.source.length) {
            addText('Sources:', margin + 5, 9, 'bold', [100,100,100]);
            sol.source.forEach((src: string) => {
              if (typeof src === 'string' && (src.startsWith('http://') || src.startsWith('https://'))) {
                addLink(src, src, margin + 10, 8);
              } else if (typeof src === 'string') {
                addText(src, margin + 10, 8);
              }
            });
          }
          currentY += 3;
        });
      }

      // KPIs
      if (Array.isArray(details.kpis) && details.kpis.length) {
        addSectionHeader("Key Performance Indicators", [0, 100, 200]);
        details.kpis.forEach((kpi: any) => {
          checkPageBreak(lineHeight * 2);
          const kpiText = `${kpi.title}: ${kpi.value}`;
          addText(kpiText, margin + 5, 10, 'bold');
          if (kpi.context) addText(kpi.context, margin + 5, 10);
          currentY += 2;
        });
      }

      // Solution Providers
      if (Array.isArray(details.research_comp) && details.research_comp.length) {
        addSectionHeader("Solution Providers", [0, 100, 150]);
        details.research_comp.forEach((rc: any, index: number) => {
          checkPageBreak(lineHeight * 3);
          addText(`${index + 1}. ${rc.company} (${rc.type})`, margin + 5, 11, 'bold');
          if (rc.client) addText(`Client: ${rc.client}`, margin + 5, 9, 'italic', [100,100,100]);
          if (rc.solution) addText(rc.solution, margin + 5, 10);

          if (rc.source && Array.isArray(rc.source) && rc.source.length) {
            addText('Sources:', margin + 5, 9, 'bold', [100,100,100]);
            rc.source.forEach((src: string) => {
              if (typeof src === 'string' && (src.startsWith('http://') || src.startsWith('https://'))) {
                addLink(src, src, margin + 10, 8);
              } else if (typeof src === 'string') {
                addText(src, margin + 10, 8);
              }
            });
          }
          currentY += 3;
        });
      }

      // Datasets
      if (Array.isArray(details.data_inst) && details.data_inst.length) {
        addSectionHeader("Datasets", [200, 100, 0]);
        details.data_inst.forEach((ds: any, index: number) => {
          checkPageBreak(lineHeight * 2);
          addText(`${index + 1}. ${ds.dataset}`, margin + 5, 11, 'bold');
          if (ds.description) addText(ds.description, margin + 5, 10);

          if (ds.source && Array.isArray(ds.source) && ds.source.length) {
            addText('Sources:', margin + 5, 9, 'bold', [100,100,100]);
            ds.source.forEach((src: string) => {
              if (typeof src === 'string' && (src.startsWith('http://') || src.startsWith('https://'))) {
                addLink(src, src, margin + 10, 8);
              } else if (typeof src === 'string') {
                addText(src, margin + 10, 8);
              }
            });
          }
          currentY += 2;
        });
      }

      // Benefits
      if (Array.isArray(details.benefits) && details.benefits.filter((b: string) => b && b.trim()).length > 0) {
        addSectionHeader("Benefits", [0, 128, 0]);
        details.benefits.filter((b: string) => b && b.trim()).forEach((benefit: string) => {
          checkPageBreak();
          pdf.text('✓', margin + 5, currentY);
          const lines = wrapText(benefit, usableWidth - 15, 10);
          lines.forEach((line: string, idx: number) => {
            if (idx > 0) checkPageBreak();
            pdf.text(line, margin + 10, currentY);
            currentY += lineHeight;
          });
        });
        currentY += 3;
      }

      // Blog Stories
      if (Array.isArray(details.blogstories) && details.blogstories.length) {
        addSectionHeader("Blog Stories", [128, 0, 128]);
        details.blogstories.forEach((story: any, index: number) => {
          checkPageBreak(lineHeight * 3);
          addText(`${index + 1}. ${story.title}`, margin + 5, 11, 'bold');
          if (story.summary) addText(story.summary, margin + 5, 10);
          if (story.company_or_author) addText(`Author/Company: ${story.company_or_author}`, margin + 5, 9, 'italic', [100,100,100]);

          if (story.url && (story.url.startsWith('http://') || story.url.startsWith('https://'))) {
            addText('URL:', margin + 5, 9, 'bold', [100,100,100]);
            addLink(story.url, story.url, margin + 10, 8);
          }
          currentY += 3;
        });
      }

      // Statistical Analysis
      if (Array.isArray(details.data) && details.data.length) {
        addSectionHeader("Statistical Analysis", [0,0,200]);
        details.data.forEach((stat: any, index: number) => {
          checkPageBreak(lineHeight * 2);
          addText(`${index + 1}. ${stat.statistic}`, margin + 5, 11, 'bold');
          if (stat.context) addText(stat.context, margin + 5, 10);
          if (stat.source && Array.isArray(stat.source) && stat.source.length) {
            addText('Sources:', margin + 5, 9, 'bold', [100,100,100]);
            stat.source.forEach((src: string) => {
              if (typeof src === 'string' && (src.startsWith('http://') || src.startsWith('https://'))) {
                addLink(src, src, margin + 10, 8);
              } else if (typeof src === 'string') {
                addText(src, margin + 10, 8);
              }
            });
          }
          currentY += 2;
        });
      }

      // build filename safely
      const sanitizedTitle = details.title
        ? String(details.title).replace(/[^a-z0-9\s]/gi, '').replace(/\s+/g, '_').toLowerCase().substring(0, 50)
        : 'solution_details';

      const filename = `${sanitizedTitle}_${new Date().toISOString().split('T')[0]}.pdf`;
      pdf.save(filename);

      setPdfDownloadMessage(details?.is_approved
        ? "PDF downloaded successfully! ✅📄"
        : "PDF downloaded successfully! 📄"
      );
      setShowSuccessAlert(true);
      setTimeout(() => setShowSuccessAlert(false), 3000);
    } catch (error) {
      console.error("Failed to generate PDF:", error);
      setPdfDownloadMessage("Failed to generate PDF.");
      setShowErrorAlert(true);
      setTimeout(() => setShowErrorAlert(false), 3000);
    } finally {
      setIsDownloadingPdf(false);
    }
  }, [
    details,
    // selectedSector,
    // selectedSubSector,
    // selectedCountry,
    // searchQuery,
    setShowSuccessAlert,
    setShowErrorAlert,
    setIsDownloadingPdf
]);

  // Close PDF alert after 5 seconds
  useEffect(() => {
    if (pdfAlert.open) {
      const timer = setTimeout(() => {
        setPdfAlert((prev) => ({ ...prev, open: false }));
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [pdfAlert.open]);

  // Scroll detection effect
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 200);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Handle back navigation
  const handleGoBack = () => {
    navigate(-1); // Navigate to previous page in history
  };

  // Update active section using IntersectionObserver (improved)
  useEffect(() => {
    if (typeof window === "undefined") return;
    const sectionEls = Array.from(document.querySelectorAll("section[id]")) as HTMLElement[];
    if (!sectionEls.length) return;

    sectionEls.forEach(s => { visibility[s.id] = 0; });

    let ticking = false;

    const pickActive = () => {
      ticking = false;
      // Pick highest ratio; fallback to nearest to viewport center if all zero
      let bestId = "";
      let bestRatio = 0;
      for (const id of Object.keys(visibility)) {
        const r = visibility[id] ?? 0;
        if (r > bestRatio) {
          bestRatio = r;
          bestId = id;
        }
      }
      if (bestRatio < 0.05) {
        const viewportCenter = window.innerHeight / 2;
        let minDist = Infinity;
        sectionEls.forEach(sec => {
          const rect = sec.getBoundingClientRect();
          const secCenter = rect.top + rect.height / 2;
          const dist = Math.abs(secCenter - viewportCenter);
          if (dist < minDist) {
            minDist = dist;
            bestId = sec.id;
          }
        });
      }
      if (bestId && bestId !== activeSection) {
        setActiveSection(bestId);
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(e => {
          visibility[e.target.id] = e.isIntersecting ? e.intersectionRatio : 0;
        });
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(pickActive);
        }
      },
      {
        root: null,
        rootMargin: "-10% 0px -10% 0px",
        threshold: Array.from({ length: 21 }, (_, i) => i / 20), // 0..1 step .05
      }
    );

    sectionEls.forEach(sec => observer.observe(sec));
    return () => observer.disconnect();
  }, [details, activeSection]);

  /* ---------- Fixed left tracer nav with animated orange indicator ---------- */
  const navItems = [
    { id: "solutions", label: "Solutions" },
    { id: "solutions-provider", label: "Solution Provider" },
    { id: "statistical-analysis", label: "Statistical Analysis" },
    { id: "data-sets", label: "Data Sets" },
    { id: "benefits", label: "Benefits" },
    { id: "blog-stories", label: "Blog Stories" },
  ];

  const navContainerRef = useRef<HTMLDivElement | null>(null);
  const navItemRefs = useRef<Array<HTMLButtonElement | null>>([]);
  const orangeDotRef = useRef<HTMLDivElement | null>(null);

  // FIX: Move this here, not inside useEffect!
  const visibility = useRef<Record<string, number>>({}).current;

  useEffect(() => {
    const positionIndicator = () => {
      const idx = navItems.findIndex(n => n.id === activeSection);
      const btn = navItemRefs.current[idx];
      const container = navContainerRef.current;
      const orange = orangeDotRef.current;
      if (!btn || !container || !orange) return;
      const btnRect = btn.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      const top = btnRect.top - containerRect.top + btnRect.height / 2 - orange.offsetHeight / 2;
      orange.style.transform = `translateY(${Math.round(top)}px)`;
    };
    positionIndicator();
    window.addEventListener("resize", positionIndicator);
    window.addEventListener("orientationchange", positionIndicator);
    return () => {
      window.removeEventListener("resize", positionIndicator);
      window.removeEventListener("orientationchange", positionIndicator);
    };
  }, [activeSection, details]);

  return (
    <>
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .scrollbar-thin::-webkit-scrollbar {
          width: 6px;
        }

        .scrollbar-thin::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
        }

        .scrollbar-thin::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.15);
          border-radius: 10px;
        }

        .scrollbar-thin::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.25);
        }
      `}</style>
      <div
        className="min-h-screen relative flex flex-col overflow-x-hidden discover-page"
        style={{
          background:
            "radial-gradient(35% 8% at 50% 0%, rgba(255, 84, 31, 0.5) 0%, rgba(0, 0, 0, 0) 100%), black",
          color: "white",
        }}
      >
      {/* Dots + Ornaments (unchanged) */}
      <div className="absolute bg-dots" style={{
        width:"1106px",height:"500px",top:"-12px",left:"194px",
        backgroundImage:"url('/dots.png')",backgroundSize:"contain",
        backgroundRepeat:"no-repeat",pointerEvents:"none",zIndex:0
      }}/>
      <div className="hidden md:block absolute pointer-events-none select-none" style={{
        top:"40%",left:"-24px",transform:"translateY(-50%)",width:"100px",height:"250px",
        backgroundImage:"url('./disover_rounded_rectangle.png')",backgroundRepeat:"no-repeat",
        backgroundSize:"contain",zIndex:0
      }}/>
      <div className="hidden md:block absolute pointer-events-none select-none" style={{
        top:"40%",right:"-24px",transform:"translateY(-50%)",width:"100px",height:"250px",
        backgroundImage:"url('./discover_Circle.png')",backgroundRepeat:"no-repeat",
        backgroundSize:"contain",zIndex:0
      }}/>

      <div className="w-full bg-transparent border-b border-white/10 shadow-sm relative z-[1000]">
        <Navbar
          mobileMenuOpen={mobileMenuOpen}
          toggleMobileMenu={toggleMobileMenu}
        />
      </div>

      {/* Tracer Nav */}
      {!loading && (
      <div
        ref={navContainerRef}
        className="hidden md:block fixed left-6 top-1/3 z-[40]"
        style={{ width: 140, pointerEvents: "auto", top: "22%" }}
      >
        <div style={{ position: "relative", padding: "8px 0" }}>
          <div
            aria-hidden
            style={{
              position: "absolute",
              left: 20,
              top: 25,
              bottom: 25,
              width: 2,
              background: "linear-gradient(#2b2b2b, rgba(255,255,255,0.05))",
              borderRadius: 2,
              zIndex: 10, // keep this behind the dots/labels
            }}
          />
          <div
            ref={orangeDotRef}
            aria-hidden
            style={{
              position: "absolute",
              left: 13,
              width: 16,
              height: 16,
              borderRadius: 999,
              background: "radial-gradient(circle at 30% 30%, #ff7a2d, #ff4b00)",
              boxShadow: "0 6px 18px rgba(255,74,17,0.25), 0 0 10px rgba(255,110,50,0.18)",
              transform: "translateY(0px)",
              transition: "transform 300ms cubic-bezier(.25,.9,.25,1)",
              zIndex: 40,
            }}
          />
          <div style={{ display: "flex", flexDirection: "column", gap: 30 }}>
            {navItems.map((item, idx) => {
              const isActive = activeSection === item.id;
              return (
                <button
  key={item.id}
  ref={el => { navItemRefs.current[idx] = el; }}
  onClick={() =>
    document.getElementById(item.id)?.scrollIntoView({ behavior: "smooth", block: "start" })
  }
  className="flex items-center text-left"
  style={{
    gap: 14,
    background: "transparent",
    border: "none",
    padding: 0,
    margin: 0,
    cursor: "pointer",
    minHeight: 28,
    position: "relative", // <-- important: create positioning context for the dot
  }}
  aria-current={isActive ? "true" : undefined}
  aria-label={`Go to ${item.label}`}
>
  {/* small dot: absolutely positioned so it always sits on top of the line */}
  <span
    style={{
      width: 10,
      height: 10,
      borderRadius: 999,
      background: isActive ? "transparent" : "#5a5a5f",
      position: "absolute",
      left: 15,              // match orange dot's left (orange is at left:13)
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 30,
    }}
  />

  {/* label with paddingLeft so text doesn't overlap the absolute dot */}
  <span
    style={{
      paddingLeft: 34, // make room for the dot + some spacing — tweak if needed
      color: isActive ? "#ffffff" : "rgba(170,170,175,0.85)",
      fontSize: 13,
      fontWeight: isActive ? 600 : 500,
      fontFamily: "Sora, sans-serif",
      whiteSpace: "nowrap",
    }}
  >
    {item.label}
  </span>
</button>

              );
            })}
          </div>
        </div>
      </div>
      )}
      {/* Alerts */}
      {showSuccessAlert && (
        <div className="fixed top-3 left-1/2 z-[1100] -translate-x-1/2 w-full max-w-md">
          <Alert
            variant="success"
            close={true}
            onClose={() => setShowSuccessAlert(false)}
          >
            <AlertIcon>
              <CheckCircleIcon sx={{ color: "#22c55e" }} />
            </AlertIcon>
            <AlertTitle>
              {pdfDownloadMessage || "Data received successfully!"}
            </AlertTitle>
          </Alert>
        </div>
      )}
      {showErrorAlert && (
        <div className="fixed top-3 left-1/2 z-[1100] -translate-x-1/2 w-full max-w-md">
          <Alert
            variant="destructive"
            close={true}
            onClose={() => setShowErrorAlert(false)}
          >
            <AlertIcon>
              <ErrorIcon sx={{ color: "#ef4444" }} />
            </AlertIcon>
            <AlertTitle>
              {pdfDownloadMessage || "Failed to fetch solution details."}
            </AlertTitle>
          </Alert>
        </div>
      )}
      {/* PDF Alert */}
      {pdfAlert.open && (
        <div className="fixed top-3 left-1/2 z-[1100] -translate-x-1/2 w-full max-w-md">
          <Alert
            variant={pdfAlert.type === "success" ? "success" : "destructive"}
            close={true}
            onClose={() => setPdfAlert({ ...pdfAlert, open: false })}
          >
            <AlertIcon>
              {pdfAlert.type === "success" ? (
                <CheckCircleIcon sx={{ color: "#22c55e" }} />
              ) : (
                <ErrorIcon sx={{ color: "#ef4444" }} />
              )}
            </AlertIcon>
            <AlertTitle>{pdfAlert.message}</AlertTitle>
          </Alert>
        </div>
      )}

      {/* NEW: Dark layout wrapper */}
      <div className="pt-20 pb-28 flex flex-col items-center w-full relative z-10"> 
        <div className="w-full max-w-[1440px] mx-auto px-4 md:px-12 lg:pl-47 lg:pr-0">
          {/* Loader: show only navbar + loader + footer while details load */}
{loading && (
  <main className="relative z-0 flex flex-1 flex-col items-center justify-center py-54 min-h-[50vh]">
    <div className="flex flex-col items-center">
      <RippleWaveLoader />
      <span className="mt-4 text-neutral-300 text-sm">Loading details... (this may take up to 2 minutes)</span>
    </div>
    <div className="min-h-[24vh]" />
  </main>
)}

{!loading && fetchError && (
  <main className="relative z-0 flex flex-1 flex-col items-center justify-center py-24 min-h-[50vh]">
    <div className="flex flex-col items-center gap-4 max-w-md text-center px-4">
      <div className="w-16 h-16 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center">
        <svg width="32" height="32" fill="none" viewBox="0 0 24 24">
          <path d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <p className="text-neutral-300 text-sm">{fetchError}</p>
      <button
        onClick={() => {
          sessionStorage.removeItem("solutionDetails");
          navigate(0);
        }}
        className="px-6 py-2.5 rounded-full bg-[#FF541F] text-white text-sm font-semibold hover:brightness-110 transition"
      >
        Retry
      </button>
      <button
        onClick={() => navigate(-1)}
        className="text-sm text-neutral-400 hover:text-white transition"
      >
        ← Go back
      </button>
    </div>
    <div className="min-h-[24vh]" />
  </main>
)}

          {/* TOP META + ACTIONS */}
          {!loading && (
          <div className="w-full mb-10">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              <div className="flex flex-wrap gap-3">
                {/* domain and subdomain */}
                {/*
                {details?.domain && (
                  <span className="inline-flex items-center rounded-full bg-white/5 border border-white/10 px-4 py-1.5 text-xs md:text-sm font-medium tracking-wide">
                    <span className="w-2 h-2 rounded-full bg-green-500 mr-2 shadow-[0_0_6px_#22c55e]"></span>
                    {details.domain}
                  </span>
                )}
                {details?.subdomain && (
                  <span className="inline-flex items-center rounded-full bg-white/5 border border-white/10 px-4 py-1.5 text-xs md:text-sm font-medium tracking-wide">
                    <span className="w-2 h-2 rounded-full bg-sky-500 mr-2 shadow-[0_0_6px_#0ea5e9]"></span>
                    {details.subdomain}
                  </span>
                )}
                */}
              </div>
              <div className="flex flex-wrap gap-3">
                {/* approve button and the download button */}
                {/* 
                <button
                  className={`rounded-md px-5 py-2 text-sm font-semibold bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-500 hover:to-emerald-500 transition shadow-md shadow-green-600/25 disabled:opacity-50`}
                  onClick={!details?.is_approved ? handleApprove : undefined}
                  disabled={approveLoading || details?.is_approved}
                >
                  {details?.is_approved ? "Approved" : approveLoading ? "Approving..." : "Approve"}
                </button>
                <button
                  className="rounded-md px-5 py-2 text-sm font-semibold bg-gradient-to-r from-sky-600 to-indigo-600 hover:from-sky-500 hover:to-indigo-500 transition shadow-md shadow-indigo-600/25 disabled:opacity-50"
                  onClick={handleDownloadPDF}
                  disabled={isDownloadingPdf}
                >
                  {isDownloadingPdf ? "Downloading..." : "Download PDF"}
                </button>
                <button
                  onClick={handleGoBack}
                  className="rounded-md px-5 py-2 text-sm font-medium bg-white/5 border border-white/10 hover:bg-white/10 transition hidden md:inline-flex"
                >
                  Back
                </button>
                */}
              </div>
            </div>
          </div>
          )}
          {/* Meta Information & Action Buttons Bar */}
          {!loading && details && (
<div className="w-full flex flex-col gap-6 mb-10">
  {/* Navigation and Meta Info */}
  <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
    {/* Back Button and Meta Tags - Hidden on mobile */}
    <div className="hidden md:flex flex-wrap items-center gap-3">
      <button
        onClick={handleGoBack}
        className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white/90 bg-white/5 hover:bg-white/10 rounded-lg border border-white/10"
      >
        <ArrowBackIcon className="w-4 h-4" />
        Back
      </button>
      
      {/* Sector/Subsector Tags - Hidden on mobile */}
      {details?.domain && (
        <span className="inline-flex items-center rounded-full bg-white/5 border border-white/10 px-4 py-1.5 text-xs md:text-sm font-medium">
          <span className="w-2 h-2 rounded-full bg-green-500 mr-2"></span>
          {details.domain}
        </span>
      )}
      {details?.subdomain && (
        <span className="inline-flex items-center rounded-full bg-white/5 border border-white/10 px-4 py-1.5 text-xs md:text-sm font-medium">
          <span className="w-2 h-2 rounded-full bg-sky-500 mr-2"></span>
          {details.subdomain}
        </span>
      )}
    </div>

    {/* Action Buttons - Desktop only */}
    <div className="hidden md:flex flex-wrap gap-3">
      <button
        className={`inline-flex items-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white/20 disabled:opacity-70 ${details?.is_approved ? "cursor-not-allowed" : "hover:brightness-110 active:scale-95"}`}
        onClick={handleApprove}
        disabled={approveLoading || details?.is_approved}
        style={{
          backgroundColor: "#0D8C3E",
          color: "#ffffff",
          boxShadow: details?.is_approved
            ? "0 2px 8px rgba(13, 140, 62, 0.20)"
            : "0 8px 20px rgba(13, 140, 62, 0.40), 0 2px 8px rgba(13, 140, 62, 0.25)",
          border: "1px solid rgba(255,255,255,0.15)",
          pointerEvents: details?.is_approved ? "none" : undefined
        }}
        aria-disabled={approveLoading || details?.is_approved}
        aria-label={details?.is_approved ? "Saved" : "Save"}
        onMouseEnter={(e) => {
          if (!details?.is_approved && !approveLoading) {
            e.currentTarget.style.boxShadow = "0 12px 28px rgba(13, 140, 62, 0.50), 0 4px 12px rgba(13, 140, 62, 0.30)";
            e.currentTarget.style.transform = "translateY(-1px)";
          }
        }}
        onMouseLeave={(e) => {
          if (!details?.is_approved && !approveLoading) {
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(13, 140, 62, 0.40), 0 2px 8px rgba(13, 140, 62, 0.25)";
            e.currentTarget.style.transform = "translateY(0)";
          }
        }}
      >
        {details?.is_approved ? (
          <>
            <CheckCircleIcon className="w-4 h-4" />
            Saved
          </>
        ) : approveLoading ? (
          "Saving..."
        ) : (
          "Save"
        )}
      </button>
      <button
        className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold bg-transparent border border-white/15 hover:bg-white/10 hover:border-white/25 hover:shadow-lg active:scale-95 transition-all duration-200 mr-4 disabled:opacity-50"
        onClick={handleDownloadPDF}
        disabled={isDownloadingPdf}
        aria-label="Download PDF"
        style={{
          backdropFilter: "blur(8px)"
        }}
      >
        <DownloadIcon className="w-4 h-4" />
        {isDownloadingPdf ? "Downloading..." : "Download PDF"}
      </button>
    </div>
  </div>

  {/* Mobile View - Fixed Bottom Bar */}
  {!loading && (
  <div
    className="
      md:hidden fixed bottom-0 left-0 right-0
      bg-gradient-to-t from-black/95 via-black/85 to-black/60
      border-t border-white/10
      px-3 pt-2
      pb-[calc(0.55rem+env(safe-area-inset-bottom))]
      backdrop-blur-xl
      z-50
      shadow-[0_-4px_20px_-4px_rgba(0,0,0,0.6)]
    "
  >
    <div className="flex gap-2.5 max-w-lg mx-auto">
      <button
        className={`
          flex-1 rounded-full py-3
          text-[0.85rem] font-semibold tracking-wide uppercase
          transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white/20
          ${details?.is_approved ? "cursor-not-allowed" : "active:scale-[0.97] hover:brightness-110"}
          disabled:opacity-55
        `}
        onClick={handleApprove}
        disabled={approveLoading || details?.is_approved}
        style={{
          backgroundColor: "#0D8C3E",
          color: "#ffffff",
          boxShadow: details?.is_approved
            ? "0 2px 8px rgba(13, 140, 62, 0.20)"
            : "0 8px 20px rgba(13, 140, 62, 0.45), 0 2px 8px rgba(13, 140, 62, 0.30)",
          border: "1px solid rgba(255,255,255,0.15)",
          pointerEvents: details?.is_approved ? "none" : undefined
        }}
        aria-disabled={approveLoading || details?.is_approved}
        aria-label={details?.is_approved ? "Approved" : "Approve"}
      >
        {details?.is_approved
          ? "Approved"
          : approveLoading
            ? "Approving..."
            : "Approve"}
      </button>
      <button
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full py-3 text-[0.85rem] font-semibold tracking-wide uppercase bg-transparent border border-white/15 hover:bg-white/10 hover:border-white/25 transition-all duration-200 disabled:opacity-55 active:scale-[0.97]"
        onClick={handleDownloadPDF}
        disabled={isDownloadingPdf}
        style={{
          backdropFilter: "blur(8px)"
        }}
      >
        <DownloadIcon className="w-4 h-4" />
        {isDownloadingPdf ? "Loading..." : "Download"}
      </button>
    </div>
  </div>
  )}
</div>)}

          {/* HERO SECTION */}
          {!loading && details && (
            <div className="w-full text-center mb-20 md:mb-28">
              {/* Title */}
              <div className="mb-8 md:mb-12">
                <h1
                  className="
                    font-[Sora] font-bold
                    text-white
                    px-4 md:px-6
                    max-w-5xl mx-auto
                  "
                  style={{
                    fontSize: "clamp(1.75rem, 5vw, 3rem)",
                    lineHeight: "1.2",
                    letterSpacing: "-0.02em",
                    animation: "fadeIn 0.6s ease-out",
                    textShadow: "0 2px 20px rgba(0, 0, 0, 0.3)"
                  }}
                >
                  {details?.title || "Solution Details"}
                </h1>
              </div>

              {/* Problem Statement */}
              <div className="max-w-4xl mx-auto px-4 md:px-6">
                <div
                  className="
                    inline-block
                    px-4 py-1.5
                    rounded-full
                    bg-gradient-to-r from-orange-500/20 to-amber-500/20
                    border border-orange-500/30
                    mb-5
                  "
                  style={{
                    animation: "fadeIn 0.6s ease-out 0.1s both"
                  }}
                >
                  <h2
                    className="
                      font-[Sora] font-semibold
                      text-sm md:text-base
                      text-orange-200
                      uppercase tracking-wider
                    "
                  >
                    Problem Statement
                  </h2>
                </div>

                <p
                  className="
                    font-[Sora] font-normal
                    text-[1rem] md:text-[1.15rem]
                    text-neutral-200
                    max-w-3xl mx-auto
                  "
                  style={{
                    lineHeight: "1.8",
                    letterSpacing: "0.01em",
                    animation: "fadeIn 0.6s ease-out 0.2s both"
                  }}
                >
                  {details.description}
                </p>
              </div>
            </div>
          )}

          {/* CONTENT */}
          {!loading && details && (
            <div className="w-full space-y-28">
              {/* Solutions */}
              {Array.isArray(details.solutions) && details.solutions.length > 0 && (
                <CardGridSection
                  id="solutions"
                  title="Solutions"
                  accent="from-neutral-500 to-neutral-400"
                  items={details.solutions.map((s:any)=>({
                    heading:s.approach,
                    body:s.summary,
                    meta: "", // Removed Technology/Tool
                    sources:s.source
                  }))}
                  openIndex={openSolutionSource}
                  setOpenIndex={setOpenSolutionSource}
                  colorKey="teal"
                />
              )}

              {/* Solution Provider */}
              {(() => {
                const providers = extractProviders(details);
                return Array.isArray(providers) && providers.length > 0 ? (
                  <>
                    <CardGridSection
                      id="solutions-provider"
                      title="Solutions Provider"
                      accent="from-orange-500 to-amber-500"
                      items={providers.map((r: any) => ({
                        heading: `${r.company ?? ""} ${r.type ? `(${r.type})` : ""}`.trim(),
                        body: r.solution ?? "",
                        meta: r.client ? `Client: ${r.client}` : "",
                        sources: r.source ?? [],
                        companyInfo: r.company ?? ""
                      }))}
                      openIndex={openAdoptedSource}
                      setOpenIndex={setOpenAdoptedSource}
                      colorKey="orange"
                      details={details} // <-- Pass details here
                    />

                    {/* Show More Button */}
                    <div className="flex justify-center mt-6">
                      <button
                        onClick={handleShowMoreProviders}
                        disabled={moreProvidersLoading}
                        className="
                          px-8 py-3
                          rounded-full
                          bg-gradient-to-r from-orange-500 to-amber-500
                          text-white font-semibold text-sm
                          shadow-lg shadow-orange-500/30
                          hover:shadow-xl hover:shadow-orange-500/40
                          hover:brightness-110
                          active:scale-95
                          disabled:opacity-60
                          disabled:cursor-not-allowed
                          transition-all duration-200
                          flex items-center gap-2
                        "
                        style={{
                          border: "1px solid rgba(255, 255, 255, 0.15)"
                        }}
                      >
                        {moreProvidersLoading ? (
                          <>
                            <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                            Loading...
                          </>
                        ) : (
                          "Show More Solution Providers"
                        )}
                      </button>
                    </div>
                  </>
                ) : null;
              })()}

              {/* Statistical Analysis */}
              {Array.isArray(details.data) && details.data.length > 0 && (
                <CardGridSection
                  id="statistical-analysis"
                  title="Statistical Analysis"
                  accent="from-violet-500 to-indigo-400"
                  items={details.data.map((d:any)=>({
                    heading: d.statistic || "",
                    body: d.context || "",
                    meta: "",  // You can add meta information if needed
                    sources: d.source || []
                  }))}
                  openIndex={openStatsSource}
                  setOpenIndex={setOpenStatsSource}
                  colorKey="purple"
                />
              )}

              {/* Data Sets */}
              {Array.isArray(details.data_inst) && details.data_inst.length > 0 && (
                <CardGridSection
                  id="data-sets"
                  title="Data Sets"
                  accent="from-neutral-500 to-neutral-400"
                  items={details.data_inst.map((d:any)=>({
                    heading: d.dataset || "",
                    body: d.description || "",
                    meta: "", // You can add meta information if needed
                    sources: d.source || []
                  }))}
                  openIndex={openDatasetSource}
                  setOpenIndex={setOpenDatasetSource}
                  colorKey="orange"
                />
              )}

              {/* Benefits */}
              {Array.isArray(details.benefits) && details.benefits.filter((b:string)=>b&&b.trim()).length>0 && (
                <SectionContainer
                  title="Benefits"
                  accent="from-green-500 to-emerald-400"
                  id="benefits"
                >
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
      {details.benefits.filter((b:string)=>b&&b.trim()).map((b:string,i:number)=>(
        <div
          key={i}
          className="flex gap-4 p-6 rounded-xl bg-gradient-to-br from-[#141416] to-[#1a1a1c] hover:from-[#1a1a1c] hover:to-[#202022] transition-all duration-300"
          style={{
            border: "1px solid rgba(255, 255, 255, 0.08)",
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.03)"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 8px 24px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.05)";
            e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.12)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 4px 16px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.03)";
            e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.08)";
          }}
        >
          <p
            className="text-white text-base leading-relaxed"
            style={{
              fontFamily: "Sora, sans-serif",
              fontWeight: 400,
              lineHeight: "1.65"
            }}
          >
            {b}
          </p>
        </div>
      ))}
    </div>
                </SectionContainer>
              )}

              {/* Blog Stories */}
              {Array.isArray(details.blogstories) && details.blogstories.length > 0 && (
                <CardGridSection
                  id="blog-stories"
                  title="Blog Stories"
                  accent="from-sky-500 to-cyan-400"
                  items={details.blogstories.map((b:any)=>({
                    heading: b.title || "",
                    body: b.summary || "",
                    meta: b.company_or_author ? `Author/Company: ${b.company_or_author}` : "",
                    sources: b.url ? [b.url] : []
                  }))}
                  openIndex={openBlogSource}
                  setOpenIndex={setOpenBlogSource}
                  colorKey="blue"
                />
              )}

              {/* KPIs */}
              {Array.isArray(details.kpis) && details.kpis.length>0 && (
                <CardGridSection
                  title="Key Performance Indicators"
                  accent="from-yellow-500 to-amber-300"
                  items={details.kpis.map((k:any)=>({
                    heading:`${k.title}  ${k.value?`(${k.value})`:""}`,
                    body:k.context,
                    meta:"",
                    sources:[]
                  }))}
                  openIndex={-1}
                  setOpenIndex={()=>{}}
                  colorKey="yellow"
                  hideSourceToggle
                />
              )}

              {/* Challenges */}
              {Array.isArray(details.challenges) && details.challenges.filter((c:string)=>c&&c.trim()).length>0 && (
                <SectionContainer
                  title="Challenges"
                  accent="from-red-500 to-neutral-400" // <-- Remove orange accent
                  id="challenges"
                >
                  <div className="grid md:grid-cols-2 gap-4">
                    {details.challenges.filter((c:string)=>c&&c.trim()).map((c:string,i:number)=>(
                      <div key={i} className="flex gap-3">
                        <span className="mt-1 w-2 h-2 rounded-full bg-gradient-to-r from-red-400 to-orange-400 shadow-[0_0_6px_#f97316]"></span>
                        <p className="text-neutral-200 text-sm md:text-base leading-relaxed">{c}</p>
                      </div>
                    ))}
                  </div>
                </SectionContainer>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Scroll To Top (unchanged logic) */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="hidden md:flex fixed bottom-6 right-2 z-10 bg-white text-neutral-500 rounded-full shadow-lg w-12 h-12 flex items-center justify-center transition hover:bg-neutral-50 border-2 border-neutral-500 group"
          aria-label="Scroll to top"
        >
          <svg 
      xmlns="http://www.w3.org/2000/svg" 
      className="h-6 w-6 transition-transform group-hover:-translate-y-1" 
      fill="none" 
      viewBox="0 0 24 24" 
      stroke="currentColor"
      strokeWidth={2}
    >
      <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        d="M5 10l7-7m0 0l7 7m-7-7v18"
      />
    </svg>
        </button>
      )}

      <div className="mt-12 relative z-[60]">
        <Footer />
      </div>
    </div>
    </>
  );
};

export default DetailsPage;

/* ---------- ADD BELOW (helper components) ---------- */
interface SectionContainerProps {
  title:string;
  accent:string;
  id?:string;
  children:React.ReactNode;
  big?:boolean;
}
const SectionContainer = ({title,accent,id,children,big}:SectionContainerProps) => (
  <section id={id} className="space-y-6">
    <div className="text-center">
      {title === "Solutions" || 
       title === "Solutions Provider" || 
       title === "Statistical Analysis" || 
       title === "Data Sets" || 
       title === "Benefits" || 
       title === "Blog Stories" ? (
        <h2
          style={{
            fontFamily: "Sora, sans-serif",
            fontWeight: 600,
            fontStyle: "normal",
            fontSize: "38px",
            lineHeight: "150%",
            letterSpacing: "0",
            textAlign: "center",
            color: "#FFFFFF",
            margin: 0,
          }}
        >
          {title}
        </h2>
      ) : (
        <h2 className="inline-block text-xl md:text-3xl font-semibold tracking-tight">
          <span className={`bg-gradient-to-r ${accent} bg-clip-text text-transparent`}>
            {title}
          </span>
        </h2>
      )}
    </div>
    <div className={`${big ? "pt-8 md:pt-12" : "pt-6 md:pt-8"} w-full`}>
      {children}
    </div>
  </section>
);

interface GridItem {
  heading: string;
  body: string;
  meta: string;
  sources: any;
  companyInfo?: string; // Add this property to fix the error
}
interface CardGridSectionProps {
  id?: string;
  title: string;
  accent: string;
  items: GridItem[];
  openIndex: number | null | -1;
  setOpenIndex: (i: number | null) => void;
  colorKey: "teal" | "pink" | "purple" | "orange" | "blue" | "yellow";
  hideSourceToggle?: boolean;
  details?: any; // <-- Add this line
}
const glowMap:Record<string,string> = {
  teal:"from-teal-400 via-cyan-300 to-transparent",
  pink:"from-pink-400 via-rose-300 to-transparent",
  purple:"from-violet-400 via-fuchsia-300 to-transparent",
  orange:"from-orange-400 via-amber-300 to-transparent",
  blue:"from-sky-400 via-cyan-300 to-transparent",
  yellow:"from-amber-300 via-yellow-200 to-transparent"
};
const borderMap:Record<string,string> = {
  teal:"hover:border-teal-400/40",
  pink:"hover:border-pink-400/40",
  purple:"hover:border-violet-400/40",
  orange:"hover:border-orange-400/40",
  blue:"hover:border-sky-400/40",
  yellow:"hover:border-amber-300/40"
};
const CardGridSection = ({
  id,
  title,
  accent,
  items,
  openIndex,
  setOpenIndex,
  colorKey,
  hideSourceToggle,
  details // <-- Add this line
}: CardGridSectionProps) => {
  const navigate = useNavigate(); // ensure navigate is available inside this component

  const isSpecialCard = title === "Solutions" ||
                       title === "Solutions Provider" ||
                       title === "Statistical Analysis" ||
                       title === "Data Sets" ||
                       title === "Blog Stories";

  // Source dropdown refs (existing)
  const sourceBtnRefs = useRef<(HTMLButtonElement|null)[]>([]);
  const sourceDropdownRefs = useRef<(HTMLDivElement|null)[]>([]);

  // Company-info dropdown state + refs (NEW)
  const [companyOpenIndex, setCompanyOpenIndex] = useState<number|null>(null);
  const companyBtnRefs = useRef<(HTMLButtonElement|null)[]>([]);
  const companyDropdownRefs = useRef<(HTMLDivElement|null)[]>([]);
  // const [companyInfoLoading, setCompanyInfoLoading] = useState<Record<number, boolean>>({});
  // const [companyInfoData, setCompanyInfoData] = useState<Record<number, any>>({});

  // Close on outside click + ESC for either sources OR company-info
  useEffect(() => {
    if (!isSpecialCard) return;
    const handleOutside = (e: MouseEvent | TouchEvent) => {
      // handle source dropdown outside click
      if (openIndex !== null) {
        const btn = sourceBtnRefs.current[openIndex];
        const panel = sourceDropdownRefs.current[openIndex];
        if (btn && btn.contains(e.target as Node)) {
          // clicked source button -> let normal handler toggle
        } else if (panel && panel.contains(e.target as Node)) {
          // clicked inside source panel
        } else {
          setOpenIndex(null);
        }
      }
      // handle company dropdown outside click
      if (companyOpenIndex !== null) {
        const cbtn = companyBtnRefs.current[companyOpenIndex];
        const cpanel = companyDropdownRefs.current[companyOpenIndex];
        if (cbtn && cbtn.contains(e.target as Node)) {
          // clicked company button -> ignore (toggle handled by button)
        } else if (cpanel && cpanel.contains(e.target as Node)) {
          // clicked inside company panel
        } else {
          setCompanyOpenIndex(null);
        }
      }
    };
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setOpenIndex(null);
        setCompanyOpenIndex(null);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("touchstart", handleOutside);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
      document.removeEventListener("keydown", handleKey);
    };
  }, [openIndex, companyOpenIndex, isSpecialCard, setOpenIndex]);

  // function to fetch company info (similar to older handler)
  // const fetchCompanyInfo = async (index: number, firmName: string) => {
  //   if (!firmName) return;
  //   if (companyInfoData[index]) {
  //     return;
  //   }
  //   setCompanyInfoLoading((p) => ({ ...p, [index]: true }));
  //   try {
  //     const res = await fetch(`${BASE_URL}/get_firm_info`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ firm_name: firmName }),
  //     });
  //     if (res.ok) {
  //       const payload = await res.json();
  //       setCompanyInfoData((p) => ({ ...p, [index]: payload.data }));
  //     } else {
  //       setCompanyInfoData((p) => ({ ...p, [index]: null }));
  //     }
  //   } catch (e) {
  //     setCompanyInfoData((p) => ({ ...p, [index]: null }));
  //   } finally {
  //     setCompanyInfoLoading((p) => ({ ...p, [index]: false }));
  //   }
  // };

  return (
    <SectionContainer id={id} title={title} accent={accent}>
      {isSpecialCard ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 justify-items-center">
          {items.map((it, idx) => (
            <div
              key={idx}
              className="relative flex flex-col w-full max-w-[480px]" // CHANGED: width handling
              style={{
                minHeight: "200px",
                gap: "12px",
                borderRadius: "20px",
                padding: "32px 28px",
                background:
                  "linear-gradient(135deg, rgba(20, 20, 22, 0.95) 0%, rgba(30, 30, 35, 0.9) 100%)",
                border: "1px solid rgba(255, 255, 255, 0.08)",
                backdropFilter: "blur(12px)",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.05)",
                zIndex: openIndex === idx || companyOpenIndex === idx ? 1000 : 1,
                overflow: "visible",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow = "0 12px 40px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.08)";
                e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.05)";
                e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.08)";
              }}
            >
              <h3
                className="
                  font-[Sora] font-semibold
                  text-[1rem] md:text-[1.15rem]
                  leading-tight text-white
                  mb-3
                "
                style={{
                  letterSpacing: "-0.01em",
                  lineHeight: "1.4"
                }}
              >
                {truncate(it.heading, 110)}
              </h3>

              <p
                className="
                  font-[Sora] font-normal
                  text-[0.85rem] md:text-[0.95rem]
                  leading-relaxed
                  text-neutral-300/90
                  flex-1
                  overflow-y-auto
                  pr-1
                  max-h-[220px] md:max-h-[260px]
                  scrollbar-thin
                "
                style={{
                  lineHeight: "1.7",
                  letterSpacing: "0.01em"
                }}
              >
                {it.body}
              </p>

              {/* Show client info below card content for Solutions Provider only */}
              {title === "Solutions Provider" && it.meta && (
                <div
                  className="
                    font-[Sora] font-medium
                    text-[0.75rem] md:text-[0.85rem]
                    text-white/95
                    mt-3
                    bg-gradient-to-r from-white/8 to-white/5
                    rounded-lg
                    px-4 py-2.5
                    border border-white/15
                    truncate
                    text-left
                    transition-all duration-200
                  "
                  style={{
                    backdropFilter: "blur(8px)",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)"
                  }}
                  title={it.meta}
                >
                  {it.meta}
                </div>
              )}

              {/* Bottom action row (buttons) */}
              {((!hideSourceToggle && Array.isArray(it.sources) && it.sources.length>0) || it.companyInfo) && (
                <div className="flex justify-between items-center mt-5 gap-4 relative">
                  <div className="flex gap-3 items-center">
                    {!hideSourceToggle && Array.isArray(it.sources) && it.sources.length>0 && (
                      <div className="relative">
                        <button
                          ref={el => { sourceBtnRefs.current[idx] = el; }}
                          onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                          type="button"
                          className="
                            flex items-center gap-2
                            font-[Sora] font-medium
                            text-[0.75rem] tracking-wide
                            rounded-full
                            px-5 py-2.5
                            bg-gradient-to-b from-neutral-700/40 to-neutral-800/50
                            border border-neutral-500/50
                            text-neutral-200
                            hover:text-white hover:border-neutral-400/70
                            hover:shadow-lg hover:shadow-neutral-900/50
                            active:scale-95
                            transition-all duration-200
                          "
                          style={{
                            backdropFilter: "blur(8px)"
                          }}
                          aria-expanded={openIndex===idx}
                        >
                          <span>Source</span>
                          <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${openIndex===idx?"rotate-180":""}`} />
                        </button>

                        {openIndex===idx && (
                          <div
                            ref={el => { sourceDropdownRefs.current[idx] = el; }}
                            id={`solution-sources-${idx}`}
                            role="region"
                            aria-label="Source links"
                            className="absolute left-0 mt-2 w-[min(480px,90vw)]"
                            style={{
                              zIndex:2000,
                              background:"rgba(18,18,20,0.95)",
                              border:"1px solid rgba(67,72,84,0.6)",
                              borderRadius:12,
                              padding:10,
                              boxShadow:"0 8px 24px rgba(0,0,0,0.5)",
                              backdropFilter:"blur(12px)"
                            }}
                          >
                            <ul className="flex flex-col gap-2 m-0 p-0" style={{listStyle:"none"}}>
                              {(Array.isArray(it.sources)?it.sources:[it.sources]).map((src:any,sidx:number)=>{
                                if(!src) return null;
                                let domain = src;
                                let displayTitle = src;
                                try{
                                  const u=new URL(src);
                                  domain=u.hostname.replace(/^www\./i,"");
                                  displayTitle=domain;
                                }catch{}
                                return (
                                  <li key={sidx}>
                                    {isUrl(src) ? (
                                      <a
                                        href={src}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-start gap-3 p-3 rounded-lg hover:bg-white/5 transition-all duration-200 border border-white/5 hover:border-orange-500/30 group"
                                        style={{ textDecoration:"none" }}
                                      >
                                        <img
                                          src={`https://www.google.com/s2/favicons?domain=${domain}&sz=64`}
                                          alt={`${domain} favicon`}
                                          style={{
                                            width:32,
                                            height:32,
                                            borderRadius:6,
                                            background:"transparent",
                                            objectFit:"cover",
                                            flexShrink:0,
                                            filter:"grayscale(100%) opacity(0.95)",
                                            marginTop:2
                                          }}
                                        />
                                        <div style={{minWidth:0,flex:1}}>
                                          <div style={{
                                            color: "#ffffff",
                                            fontWeight:500,
                                            fontSize:"0.95rem",
                                            fontFamily:"Sora, sans-serif",
                                            marginBottom:4,
                                            transition:"color 0.2s"
                                          }}
                                          className="group-hover:text-orange-400">
                                            {displayTitle}
                                          </div>
                                          <div style={{
                                            fontSize: 12,
                                            color: "#737373",
                                            wordBreak:"break-all",
                                            lineHeight:1.5,
                                            fontFamily:"Sora, sans-serif"
                                          }}>
                                            {src}
                                          </div>
                                        </div>
                                        <svg
                                          className="w-4 h-4 flex-shrink-0 text-neutral-400 group-hover:text-orange-400 transition-colors"
                                          style={{ marginTop:4 }}
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24"
                                        >
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                        </svg>
                                      </a>
                                    ) : (
                                      <div className="flex items-start gap-3 p-3 rounded-lg border border-white/5">
                                        <div style={{minWidth:0,flex:1}}>
                                          <span style={{ color: "#ffffff", fontWeight:500, fontSize:"0.95rem", fontFamily:"Sora, sans-serif" }}>
                                            {truncate(String(src),60)}
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Right side: meta pill + company info button */}
                  <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    {/* {title !== "Solutions Provider" && it.meta && (
                      <div style={{
                        fontFamily:"Sora, sans-serif",
                        fontWeight:500,
                        fontSize:"12px",
                        color:"#FFFFFF",
                        padding:"10px 22px",
                        borderRadius:"999px",
                        border:"1px solid rgba(255,255,255,0.12)",
                        background:"rgba(0,0,0,0.25)",
                        backdropFilter:"blur(4px)",
                        whiteSpace:"nowrap",
                        maxWidth:"100%",
                        overflow:"hidden",
                        textOverflow:"ellipsis"
                      }}
                        title={it.meta}
                      >
                        {it.meta}
                      </div>
                    )} */}
                    {/* paragraph that renders it.body is above — insert the pill right after it */}

{ /* new wrapped meta pill — shows under the text and wraps */ }
{title !== "Solutions Provider" && it.meta && (
  <div
    style={{
      display: "inline-block",
      marginTop: 12,
      fontFamily: "Sora, sans-serif",
      fontWeight: 500,
      fontSize: "12px",
      color: "#FFFFFF",
      padding: "6px 12px",
      borderRadius: 999,
      border: "1px solid rgba(255,255,255,0.08)",
      background: "rgba(255,255,255,0.03)",
      backdropFilter: "blur(4px)",
      whiteSpace: "normal",        // allow wrapping
      maxWidth: "100%",
      wordBreak: "break-word",     // break long words/URLs
      overflowWrap: "anywhere"
    }}
    title={it.meta}
  >
    {it.meta}
  </div>
)}

                    {/* Company Info button */}
                    {it.companyInfo && (
                      <button
                        onClick={() => {
                          // Navigate to company details page with required info
                          navigate(`/solution-company/${encodeURIComponent(it.companyInfo ?? "")}`, {
                            state: {
                              companyName: it.companyInfo ?? "",
                              title: details?.title,
                              description: details?.description
                            }
                          });
                        }}
                        className="
                          flex items-center gap-2
                          font-[Sora] font-medium
                          text-[0.75rem] tracking-wide
                          rounded-full
                          px-5 py-2.5
                          bg-gradient-to-r from-orange-600/30 to-amber-600/30
                          border border-orange-500/40
                          text-orange-100
                          hover:text-white hover:border-orange-400/60
                          hover:shadow-lg hover:shadow-orange-900/30
                          active:scale-95
                          transition-all duration-200
                        "
                        style={{
                          backdropFilter: "blur(8px)"
                        }}
                      >
                        Company Info
                      </button>
                    )}
                  </div>
                </div>
              )}
           
            </div>

          ))}
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {items.map((it,idx)=>(
            <div
              key={idx}
              className={`group relative rounded-xl p-5 flex flex-col bg-[#0b0b0e] border border-white/10 transition ${borderMap[colorKey]} shadow-[0_4px_16px_-4px_rgba(0,0,0.6)] overflow-hidden`}
            >
              <div className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition">
                <div className={`absolute -top-16 -left-16 w-48 h-48 rounded-full bg-gradient-to-br ${glowMap[colorKey]} blur-2xl`} />
              </div>
              <h3 className="text-sm md:text-base font-semibold mb-2 leading-snug text-white">
                {truncate(it.heading,100)}
              </h3>
              <p className="text-xs md:text-sm text-neutral-300 leading-relaxed line-clamp-5 mb-3">
                {truncate(it.body,240)}
              </p>
              {it.meta && (
                <p className="text-[11px] md:text-xs text-neutral-400 mb-3 italic">
                  {it.meta}
                </p>
              )}
              {!hideSourceToggle && Array.isArray(it.sources) && it.sources.length>0 && (
                <div className="mt-auto">
                  <button
                    onClick={()=> setOpenIndex(openIndex===idx? null : idx)}
                    className="text-[11px] uppercase tracking-wide font-semibold bg-white/5 hover:bg-white/10 px-3 py-1 rounded-md border border-white/10 transition"
                  >
                    Sources
                    <span className={`inline-block ml-1 transition-transform ${openIndex===idx?"rotate-180":""}`}>▼</span>
                  </button>
                  {openIndex===idx && (
                    <ul className="mt-3 space-y-2 max-h-40 overflow-auto pr-1 scrollbar-thin">
                      {(Array.isArray(it.sources)?it.sources:[it.sources]).map((s:any,i:number)=>{
                        if(!s) return null;
                        const url = typeof s==="string"? s : "";
                        return (
                          <li key={i} className="text-[11px] break-all flex items-start gap-2">
                            <span className="mt-1 w-1.5 h-1.5 rounded-full bg-gradient-to-r from-neutral-400 to-neutral-500 flex-shrink-0"></span>
                            {isUrl(url)?(
                              <a href={url} target="_blank" rel="noopener noreferrer" className="text-neutral-300 hover:underline">
                                {truncate(url,80)}
                              </a>
                            ):(

                              <span className="text-neutral-300">{truncate(String(url),80)}</span>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </div>
              )}
            </div>
          ))}

        </div>
      )}
    </SectionContainer>
  );
};

// Utility helpers
function truncate(str:string,max:number){
  if(!str) return "";
  return str.length>max? str.slice(0,max-3)+"..." : str;
}
function isUrl(v:string){
  try{ new URL(v); return true; }catch{return false;}
}

// Normalize providers from either `details.research_comp` (array) or `details.research_comp.solution_providers` (array)
function extractProviders(obj: any): any[] {
  if (!obj) return [];
  if (Array.isArray(obj?.research_comp)) return obj.research_comp;
  if (Array.isArray(obj?.research_comp?.solution_providers)) return obj.research_comp.solution_providers;
  return [];
}